export default "__VITE_ASSET__ByTjjh6M__"